<template>
  <div class="min-h-screen bg-bochas-bg">
    <!-- Hero (estilo home: navbar transparente sobre el hero, fondo llega a top:0) -->
    <ImageBackgroundSection
      seed="calendario-hero"
      :image-url="heroImageUrl"
      :loading-image="heroImageLoading"
      alt="Calendario de Torneos"
      :title="heroMedia?.title || 'Calendario de Torneos'"
      :subtitle="heroMedia?.subtitle || 'Conocé las próximas fechas, sedes y competencias'"
    />

    <div v-if="error && eventos.length" class="max-w-7xl mx-auto px-6 pt-6 text-sm text-bochas-text-muted" role="status">
      No pudimos actualizar los torneos. Seguís viendo los últimos datos cargados.
      <button type="button" class="ml-2 underline" :disabled="loading" @click="load">Reintentar</button>
    </div>

    <section v-if="loading && !eventos.length" class="max-w-7xl mx-auto px-6 py-12 text-center">
      <div
        class="inline-block w-10 h-10 sm:w-12 sm:h-12 border-4 border-bochas-rojo border-t-transparent rounded-full animate-spin"
      ></div>
    </section>

    <section v-else-if="error && !eventos.length" class="max-w-7xl mx-auto px-6 py-12">
      <HomeSectionState state="error" :error-message="error" @retry="load" />
    </section>

    <!-- Calendario reutilizable: grid + lista + modal TODO incluido -->
    <section
      v-else
      class="max-w-7xl mx-auto py-16 px-6 sm:px-6 lg:px-0 lg:py-24 sm:py-12"
    >
      <div class="section-header">
        <div class="section-header__icon">
          <IconFbochas name="calendario" :size="32" color="#fff" />
        </div>
        <span class="section-header__label">Próximas fechas</span>
      </div>
      <CalendarioFbochas compact :events="eventos" />
    </section>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import HomeSectionState from "@/components/Home/HomeSectionState.vue";
import { listarEventos } from "@/services/appointments/appointmentsService";
import CalendarioFbochas from "../../components/Calendario/CalendarioFbochasComponent.vue";
import ImageBackgroundSection from "@/components/Common/ImageBackgroundSection.vue";
import IconFbochas from "../../components/Icons/IconFbochas.vue";
import { useSiteMediaImageState } from "@/composables/useSiteMediaImage";

const { imageUrl: heroImageUrl, item: heroMedia, loading: heroImageLoading } =
  useSiteMediaImageState("calendario.hero");
const eventos = ref([]);
const loading = ref(true);
const error = ref("");

async function load() {
  loading.value = true;
  error.value = "";
  try {
    const data = await listarEventos();
    eventos.value = data.items || [];
  } catch (_) {
    error.value = "No pudimos cargar los torneos. Intentá nuevamente.";
  } finally {
    loading.value = false;
  }
}

onMounted(load);
</script>
